const AlignImageLeft = () => (
  <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="11" height="16" rx="2" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M17.7071 11.7071C17.3166 12.0976 16.6834 12.0976 16.2929 11.7071L13.2929 8.70711C12.9024 8.31658 12.9024 7.68342 13.2929 7.29289L16.2929 4.29289C16.6834 3.90237 17.3166 3.90237 17.7071 4.29289C18.0976 4.68342 18.0976 5.31658 17.7071 5.70711L16.4142 7L20 7C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H16.4142L17.7071 10.2929C18.0976 10.6834 18.0976 11.3166 17.7071 11.7071Z" fill="currentColor" />
  </svg>
)

export default AlignImageLeft
